// DEVN3-521 — tipos do Laudo de Auditoria (Motor Narrativo Universal), espelham os DTOs do Core.

export type LaudoStatus = 'PENDENTE' | 'GERANDO' | 'PARCIAL' | 'CONCLUIDO' | 'ERRO'

export type CapituloStatus =
  | 'PENDENTE'
  | 'GERADO'
  | 'EM_REVISAO'
  | 'ACEITO'
  | 'REJEITADO'
  | 'ERRO'
  | 'ENTRADA_INSUFICIENTE'
  // Regra sem ERRO, ALERTA ou AVISO: não gera capítulo no laudo (fora da barra e do PDF).
  | 'SEM_APONTAMENTO'

export interface IContratoValor {
  valor: number | null
  mensurado: boolean
  exibicao: string
}

export interface IContratoTotal {
  rotulo: string
  valor: string
}

export interface IContratoTabela {
  titulo: string
  colunas: string[]
  linhas: string[][]
  totalLinhas: number
  truncada: boolean
  totais: IContratoTotal[]
}

export interface IContratoContexto {
  regime: string
  tipoAuditoria: string
  conta: string
  contaReferencial: string
  fontePrimaria: string
  fonteComparativa: string
  escopo: string
  materialidade: string
}

export interface IContratoIndicador {
  rotulo: string
  valor: string
  destaque: boolean
  severidade?: string | null
}

export interface IContratoMemoriaCalculo {
  id: string
  titulo: string
  formula: string
  componentes: IContratoTotal[]
  resultado: string
}

export interface IContratoEvidencia {
  id: string
  tipo: string
  descricao: string
  origem: string
  documento: string
  data: string
}

export interface IContratoSecao {
  titulo: string
  status: string
  descricao: string
  tabelas: IContratoTabela[]
  indicadores: IContratoIndicador[]
  memoriasCalculo: IContratoMemoriaCalculo[]
  observacoes: string[]
}

export interface IContratoPadronizado {
  regra: string
  categoria: string
  objetivo: string
  procedimento: string
  criterio: string
  empresa: string
  cnpj: string
  periodo: string
  contexto: IContratoContexto
  status: string
  totalErros: number
  totalAlertas: number
  totalAvisos: number
  mensagemDirecionamento: string
  acaoRecomendada: string
  impactoFiscalTotal: IContratoValor
  impactoFinanceiroTotal: IContratoValor
  indicadores: IContratoIndicador[]
  tabelas: IContratoTabela[]
  secoes: IContratoSecao[]
  memoriasCalculo: IContratoMemoriaCalculo[]
  fundamentacaoLegal: string
  evidencias: IContratoEvidencia[]
  observacoesSistema: string[]
  camposAusentes: string[]
}

export interface ILaudoSugestaoIa {
  abertura?: string | null
  leituraTecnica?: string | null
  fechamento?: string | null
}

export interface ILaudoCapitulo {
  id: number
  regra: string
  ordem: number
  categoria: string
  objetivo: string
  procedimento: string
  criterio: string
  statusCapitulo: CapituloStatus
  origemTexto: 'IA'
  inputCompleteness?: string | null
  warnings: string[]
  camposAusentes: string[]
  contrato?: IContratoPadronizado | null
  textoAbertura?: string | null
  textoLeituraTecnica?: string | null
  textoFechamento?: string | null
  sugestaoIa?: ILaudoSugestaoIa | null
  custoEstimadoUsd: number
  dataGeracao?: string | null
  dataAprovacao?: string | null
}

// Responsáveis do laudo (primeira etapa da revisão). Com `configurado` false e `sugestao` true,
// os ids são só o pré-preenchimento vindo do último laudo da mesma empresa: nada foi salvo ainda.
export interface ILaudoResponsaveis {
  responsavelTecnicoId?: number | null
  elaboradorId?: number | null
  revisorId?: number | null
  aprovadorId?: number | null
  dataConfiguracao?: string | null
  configurado: boolean
  sugestao: boolean
}

// Opção das listas de responsáveis: usuário ativo do cliente.
export interface ILaudoUsuarioOpcao {
  id: number
  nome: string
  registroProfissional?: string | null
}

export interface ILaudoAuditoria {
  id: number
  empresaId: number
  esteiraId: number
  status: LaudoStatus
  totalCapitulos: number
  capitulosGerados: number
  capitulosAprovados: number
  // Recusados na revisão: contam como revisados, mas ficam fora do PDF.
  capitulosRecusados: number
  inputCompletenessGeral?: string | null
  motivoErro?: string | null
  exportHabilitado: boolean
  arquivoRetornoId?: number | null
  arquivoRetornoProcessando: boolean
  arquivoRetornoPronto: boolean
  responsaveis: ILaudoResponsaveis
  capitulos: ILaudoCapitulo[]
}

// Regras da fase piloto — têm rótulo próprio da tela em vez da categoria do catálogo.
export const REGRAS_LAUDO_PILOTO = ['AUDITORIA_SOCIETARIA', 'AUDITORIA_CAIXA', 'IRPJ', 'CSLL']
